import { IEmailFamily } from "./email-family";

export interface IEmailFamilyResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailFamily
    }
}
